export type EventName =
  | 'session_start'
  | 'game_start'
  | 'word_end'
  | 'answer_wrong'
  | 'game_over'
  | 'restart_click';

export type Preset = 'A' | 'B' | 'C';

export interface TelemetryMeta {
  readonly n: EventName;
  readonly i: number; // 세션 내 일련번호 (1부터)
  readonly t: number; // Date.now()
  readonly mt: number; // round(performance.now())
  readonly uid: string;
  readonly sid: string;
}

/**
 * track() 이 붙이는 메타 키. payload 가 같은 이름을 써도 **메타가 이긴다**(`composeRow`).
 * `game_over` 가 `mt: moveTicks` 를 실어 단조 시계 `mt` 를 덮어쓴 사고의 재발 방지 —
 * 이벤트 payload 는 이 목록의 이름을 쓰면 안 된다(`test/telemetry.test.ts` 가 세션 전체 이벤트로 검사).
 * 새 메타 필드를 더하면 여기도 더한다 — 아래 `MetaKeysExhaustive` 가 누락을 컴파일 시점에 잡는다.
 */
export const META_KEYS = [
  'n',
  'i',
  't',
  'mt',
  'uid',
  'sid',
] as const satisfies readonly (keyof TelemetryMeta)[];
export type MetaKey = (typeof META_KEYS)[number];
type Exhaustive<T extends never> = T;
export type MetaKeysExhaustive = Exhaustive<Exclude<keyof TelemetryMeta, MetaKey>>;

export type Payload = Record<string, unknown>;
export type TelemetryRow = TelemetryMeta & Payload;
